import { backendUrl } from "../../config/api";
import { API_METHOD_POST } from "../../config/constants";
import { getApiHeader, queryBuilder } from "../../helper/apiActionHelper";
import { DOWNLOAD_TEST_RES_SUCCESS } from "../types/adminTypes";
import { COMMON_LOADING_RESET, COMMON_LOADING_SET } from "../types/commonTypes";

export const downloadTestResult = (body) => {
  return (dispatch) => {
    dispatch({
      type: COMMON_LOADING_SET,
    });
    const filename = "test-result.xlsx";

    var newUrl = queryBuilder("/result/checking/export", {});
    fetch(backendUrl + newUrl, {
      method: API_METHOD_POST,
      body: JSON.stringify(body),
      headers: getApiHeader(API_METHOD_POST, true, false),
    })
      .then((response) => {
        dispatch({
          type: COMMON_LOADING_RESET,
        });
        if (response.status === 500) {
          console.error("ERROR in blob");
          response
            .json()
            .then((data) => {
              alert(data?.message || "Internal Error");
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message || "Internal Error");
            });
        } else if (response.status === 401 || response.status === 403) {
          dispatch({
            type: "AUTHENTICATION_ERROR",
          });
        } else if (response.status === 200) {
          response
            .blob()
            .then((blob) => {
              const data = window.URL.createObjectURL(blob);
              var link = document.createElement("a");
              link.href = data;
              link.download = filename;
              link.click();
              setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
              }, 100);
              dispatch({
                type: DOWNLOAD_TEST_RES_SUCCESS,
              });
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else if (response.status === 201) {
          response
            .json()
            .then((data) => {
              dispatch({
                type: DOWNLOAD_TEST_RES_SUCCESS,
              });
              alert(data?.message || "Will be available shortly");
            })
            .catch((err) => {
              alert("File download error");
            });
        } else {
          console.error("ERROR in blob");
          alert("File download error");
        }
      })
      .catch((err) => {
        console.error("ERROR in catch", err);
        alert(err?.message);
      });
  };
};
